// extracted by mini-css-extract-plugin
module.exports = {"socialsList":"style_socialsList__D7jCD"};